module.exports = __webpack_public_path__ + "static/media/Avatars_Male_New-04.a9259078.png";